import { render, staticRenderFns } from "./TcLoginDni.vue?vue&type=template&id=a52f4796&"
import script from "./TcLoginDni.vue?vue&type=script&lang=js&"
export * from "./TcLoginDni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/inventia/Sites/coiico_totem/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a52f4796')) {
      api.createRecord('a52f4796', component.options)
    } else {
      api.reload('a52f4796', component.options)
    }
    module.hot.accept("./TcLoginDni.vue?vue&type=template&id=a52f4796&", function () {
      api.rerender('a52f4796', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TcLoginDni.vue"
export default component.exports